import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DnTooltipDirective } from './dn-tooltip.directive';

@NgModule({
  declarations: [DnTooltipDirective],
  imports: [CommonModule],
  exports: [DnTooltipDirective],
})
export class DnTooltipModule {}
